import { render, staticRenderFns } from "./brandForm.vue?vue&type=template&id=4f38422a&scoped=true"
import script from "./brandForm.vue?vue&type=script&lang=js"
export * from "./brandForm.vue?vue&type=script&lang=js"
import style0 from "./brandForm.vue?vue&type=style&index=0&id=4f38422a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f38422a",
  null
  
)

export default component.exports